/** @module messageData */

export const stageData = [
  {
    color: "success",
    text: "A.D. 78: Vesuvius Sleeps"
  },
  {
    color: "warning",
    text: "A.D. 79: Vesuvius SEETHES!"
  },
  {
    color: "danger",
    text: "A.D. 79: VESUVIUS ERUPTS!"
  }
];

export const phaseMessage = ["Play a Card", "Place a Person", "Draw a Card"];
